module.exports = __webpack_public_path__ + "img/371.1e84a6c4.jpg";